<template>
  <div class="box">
    <el-dialog :visible.sync="visible" :width="width" :modal-append-to-body="false">
      <div slot="title" style="border-bottom:1px solid #ccc;padding-bottom:10px;">
        <div v-if="type == 1">
          “
          <span style="color:red">{{title.user_name}}</span>
          ” 的 “
          <span style="color:red">{{title.pro_name}}</span>
          ” 手术项目救助拨款申请信息
        </div>
        <div v-else-if="type == 2">
          “
          <span style="color:red">{{title.pro_name}}</span>
          ” 非手术项目拨款申请信息
        </div>
      </div>

      <template v-if="type == 1">
        <el-row :gutter="20" justify="center" style="padding:10px 0px">
          <el-col :span="6" :offset="2">
            <span class="box-title">申请人姓名：</span>
            <span class="box-value">{{ detailInfo.apply_user_name}}</span>
          </el-col>
          <el-col :span="6">
            <span class="box-title">申请项目：</span>
            <span class="box-value">{{ detailInfo.project_name }}</span>
          </el-col>
          <el-col :span="6" :offset="2">
            <span class="box-title">收款单位名称：</span>
            <span class="box-value">{{ detailInfo.payee_unit_name}}</span>
          </el-col>
        </el-row>

        <el-row :gutter="20" justify="center" style="padding:10px 0px">
          <el-col :span="6" :offset="2">
            <span class="box-title">医保结算时间：</span>
            <span class="box-value">{{ detailInfo.ybjssj}}</span>
          </el-col>
          <el-col :span="6">
            <span class="box-title">开户行：</span>
            <span class="box-value">{{ detailInfo.bank_name}}</span>
          </el-col>
          <el-col :span="6" :offset="2">
            <span class="box-title">开户名：</span>
            <span class="box-value">{{ detailInfo.account_name }}</span>
          </el-col>
        </el-row>

        <el-row :gutter="20" justify="center" style="padding:10px 0px">
          <el-col :span="10" :offset="2">
            <span class="box-title">银行卡号：</span>
            <span class="box-value">{{ detailInfo.account_number}}</span>
          </el-col>
          <el-col :span="10" :offset="2">
            <span class="box-title">备注：</span>
            <span class="box-value">{{ detailInfo.apply_remark }}</span>
          </el-col>
        </el-row>

        <el-row :gutter="20" justify="center" style="padding:10px 0px">
          <el-col :span="10" :offset="2">
            <span class="box-title">基金会救助金额：</span>
            <span class="box-value">{{ detailInfo.apply_money}}</span>
            <el-tooltip
              class="item"
              effect="dark"
              :content="'原申请金额：'+detailInfo.apply_amount+ '元；基金会审批金额为：'+detailInfo.approve_amount+'元'"
              placement="top"
            >
              <i class="el-icon-question" style="cursor:pointer;"></i>
            </el-tooltip>
          </el-col>
          <el-col :span="10" :offset="2">
            <span class="box-title">治疗总费用：</span>
            <span class="box-value">{{ detailInfo.zlzfy }}</span>
          </el-col>
        </el-row>

        <el-row :gutter="20" justify="center" style="padding:10px 0px">
          <el-col :span="10" :offset="2">
            <span class="box-title">其它金额：</span>
            <span class="box-value">{{ detailInfo.zfje}}</span>
            <el-tooltip effect="dark" content="计算规则：其它金额 = 治疗总费用-基金会救助金额-医保报销金额" placement="top">
              <i class="el-icon-question" style="cursor:pointer;"></i>
            </el-tooltip>
            <p></p>
          </el-col>
          <el-col :span="10" :offset="2">
            <span class="box-title">医保报销金额：</span>
            <span class="box-value">{{ detailInfo.ybbxje }}</span>
          </el-col>
        </el-row>
        <el-row :gutter="20" justify="center" style="padding:10px 0px" v-if="detailInfo.remarks">
          <el-col :span="20" :offset="2">
            <span class="box-title">其它金额备注：</span>
            <span class="box-value">{{detailInfo.remarks}}</span>
          </el-col>
        </el-row>
      </template>
      <template v-if="type == 2">
        <el-row :gutter="20" justify="center" style="padding:10px 0px">
          <el-col :span="10" :offset="2">
            <span class="box-title">申请项目：</span>
            <span class="box-value">{{ detailInfo.project_name }}</span>
          </el-col>
          <el-col :span="10" :offset="2">
            <span class="box-title">申请金额：</span>
            <span class="box-value">{{ detailInfo.apply_money}}</span>
          </el-col>
        </el-row>

        <el-row :gutter="20" justify="center" style="padding:10px 0px">
          <el-col :span="10" :offset="2">
            <span class="box-title">收款单位名称：</span>
            <span class="box-value">{{ detailInfo.payee_unit_name }}</span>
          </el-col>
          <el-col :span="10" :offset="2">
            <span class="box-title">项目负责人姓名：</span>
            <span class="box-value">{{ detailInfo.payee_rela_user_name }}</span>
          </el-col>
        </el-row>

        <el-row :gutter="20" justify="center" style="padding:10px 0px">
          <el-col :span="10" :offset="2">
            <span class="box-title">项目负责人联系方式：</span>
            <span class="box-value">{{ detailInfo.payee_telephone}}</span>
          </el-col>
          <el-col :span="10" :offset="2">
            <span class="box-title">开户行：</span>
            <span class="box-value">{{ detailInfo.bank_name }}</span>
          </el-col>
        </el-row>

        <el-row :gutter="20" justify="center" style="padding:10px 0px">
          <el-col :span="10" :offset="2">
            <span class="box-title">开户名：</span>
            <span class="box-value">{{ detailInfo.account_name}}</span>
          </el-col>
          <el-col :span="10" :offset="2">
            <span class="box-title">银行卡号：</span>
            <span class="box-value">{{ detailInfo.account_number }}</span>
          </el-col>
        </el-row>

        <el-row :gutter="20" justify="center" style="padding:10px 0px;" v-if="type === 2">
          <el-col :span="20" :offset="2">
            <p class="box-title">费用组成单：</p>
            <el-table
              :data="detailInfo.costs"
              border
              style="width: 100%"
              show-summary
              :summary-method="getSummaries"
            >
              <el-table-column prop="cost_item_name" label="物资" align="center"></el-table-column>
              <el-table-column prop="number" label="数量" align="center"></el-table-column>
              <el-table-column prop="unit_price" label="单价" align="center"></el-table-column>
              <el-table-column prop="total" label="总价" align="center"></el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </template>

      <el-row :gutter="20" justify="center" style="padding:10px 0px;" v-if="type == 1">
        <el-col :span="20" :offset="2">
          <span class="box-title">手术照片：</span>
          <template v-if="detailInfo.operation_files_path && detailInfo.operation_files_path[0]">
            <!-- <span
              v-for="val in  detailInfo.operation_files_path"
              :key="val.id"
              @click="downFile(val.id, val.name)"
              style="text-decoration: underline;cursor: pointer;color:#4682B4;margin-right:8px "
            >{{val.name}}</span>-->
            <a
              style="margin-right:8px;"
              :href="item.url"
              target="_blank"
              v-for="(item,index) in detailInfo.operation_files_path"
              :key="index"
            >{{item.name}}</a>
          </template>

          <span v-else style="color:red">暂未上传~</span>
          <p style="clear: both;" v-if="detailInfo.operation_files_path[0]">
            <i class="el-icon-warning" size="18" style="clear: both;"></i>&nbsp;点击文件名可进行下载
          </p>
        </el-col>
      </el-row>

      <el-row :gutter="20" justify="center" style="padding:10px 0px;">
        <el-col
          :span="20"
          :offset="2"
          v-if="detailInfo.files_details && detailInfo.files_details[0]"
        >
          <p class="box-title">提交的附件：</p>
          <div
            v-for="(item,index) in detailInfo.files_details"
            style="display:flex;padding:20px"
            :key="'fitem'+index"
          >
            <span class="box-value">{{item.dict_name}}：</span>
            <template v-if="item.files_path[0]">
              <!-- <span
                v-for="(val,key) in  item.files_path"
                :key="'files'+key"
                @click="downFile(val.id, val.name)"
                style="text-decoration: underline;cursor: pointer;color:#4682B4;margin-right:8px "
              >{{val.name}}</span>-->
              <a
                style="margin-right:8px;"
                :href="val.url"
                target="_blank"
                v-for="(val,key) in item.files_path"
                :key="key"
              >{{val.name}}</a>
            </template>

            <span v-else style="color:red">暂未上传~</span>
          </div>
          <p style="clear: both; margin-left:20px" v-if="detailInfo.files_details[0]">
            <i class="el-icon-warning" size="18" style="clear: both;"></i>&nbsp;点击文件名可进行下载
            <span v-if="type == 2">，压缩文件包含：学生视力检查明细、项目相片</span>
            <span
              v-if="type == 1"
              style="color:red;text-decoration:underline;cursor:pointer;"
              @click="show_pic = true"
            >点击查看压缩文件要求</span>
          </p>
        </el-col>
        <el-col :span="20" :offset="2" v-else>
          <span class="box-title">提交的附件：</span>
          <span style="color:red">暂无附件~</span>
        </el-col>
      </el-row>
      <el-dialog :visible.sync="show_pic" title="手术项目拨款申请上传压缩文件要求" append-to-body>
        <viewer :images="['../../../../assets/images/cfpro_payout_apply.png']">
          <img width="100%" src="../../../../assets/images/cfpro_payout_apply.png" alt />
        </viewer>
      </el-dialog>

      <span slot="footer">
        <el-button type="danger" icon="el-icon-close" @click="cancelBtn" size="small">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: Object,
      default: () => {}
    },
    width: {
      type: String,
      default: "65%"
    },
    id: {
      type: [String, Number],
      default: null
    },
    pid: {
      type: [String, Number],
      default: null
    },
    type: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      detailInfo: { costs: [], operation_files_path: [], files_details: [] },
      show_pic: false //查看示意图片
    };
  },

  methods: {
    cancelBtn() {
      this.visible = false;
    },

    //计算表格合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }

        if (index === 4 || index == 1 || index == 2) {
          return "";
        }

        const values = data.map(item => Number(item[column.property]));

        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = "N/A";
        }
      });

      if (sums[3] > 0) {
        sums[3] = "总额：" + this.setMoneyFormat(sums[3]) + " 元";
      }

      // if (sums[1] > 0) {
      //   sums[1] = "平均值：" + sums[1] / data.length;
      // }
      // if (sums[2] > 0) {
      //   sums[2] = "总数：" + this.setMoneyFormat(sums[2]);
      // }

      return sums;
    },

    //千分化金额
    setMoneyFormat(num) {
      if (num) {
        let value = typeof num === "number" ? num : Number(num);
        return (value.toFixed(2) + "").replace(
          /\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,
          "$&,"
        );
      }
    },

    downFile(id, name) {
      this.$db
        .downFilePost(this.$db.config.downloadFileUrl, { file_id: id })
        .then(res => {
          if (res.hasOwnProperty("code")) {
            var enc = new TextDecoder("utf-8");
            var result = JSON.parse(enc.decode(new Uint8Array(res)));
            if (result.code !== 200) {
              this.$message.warning(result.msg);
            }
          } else {
            this.download(res, name);
          }
        });
    },
    // 下载文件
    download(data, name) {
      if (!data) {
        return;
      }
      let blob = new Blob([data], { type: "application/octet-stream" });
      let url = window.URL.createObjectURL(blob);
      let alink = document.createElement("a");
      alink.href = url;
      alink.download = name; //文件名
      alink.click();
      this.downConfirm = false;
    },

    //手术项目 获取拨款详情
    getPaymentDetail() {
      this.$db
        .post(this.$db.config.getCfProPayApplyInfo, {
          id: this.id,
          project_id: this.pid
        })
        .then(res => {
          if (res && res.code == 200) {
            this.detailInfo = res.data;
          }
        });
    }
  },
  watch: {
    visible(val) {
      this.$emit("input", val);
    },

    value: {
      handler(val) {
        this.visible = val;
      },
      immediate: true
    }
  },
  created() {
    this.getPaymentDetail();
  }
};
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/Hospital/cfproject/appropriation/detail.vue